import React, { useEffect, useState, useCallback, useRef } from 'react';
import { 
  Box, 
  Container, 
  Button, 
  Typography, 
  Card, 
  CardContent, 
  Chip, 
  IconButton, 
  Paper,
  ClickAwayListener,
  Stack
} from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import Heading from '../../Components/heading.tsx';
import { getOrders } from './action.ts';
import { editTrips, getDashboard, getOrdersDelivered, startEndTripApi } from '../Dashboard/action.ts';
import TripForm from '../Dashboard/trip-form.tsx';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import CircularProgressWithLabel from '../../Components/LoadingSymbol/loading-symbol.tsx';
import TripConfirmationModal from '../Dashboard/trip-confirmation-modal.tsx';
import {getTripButtonState} from '../../Utils/TripButtonType/get-trip-button-state.tsx';
import PhotoConfirmationModal from '../Dashboard/photo-confirmation-modal.tsx';
import CameraDialog from '../Dashboard/camera-modal.tsx';
const statusColorMap: Record<string, { light: string; dark: string }> = {
  delivered: { light: '#d4edda', dark: '#155724' },
  'partially delivered': { light: '#ffe0b2', dark: '#a35e00' },
  'vehicle assigned': { light: 'rgba(230, 230, 230, 1)', dark: '#000000ff' },
  'ofd': { light: '#cce5ff', dark: '#004085' },
  rejected: { light: '#f8d7da', dark: '#721c24' },
  attempted: { light: '#f8d7da', dark: '#721c24' },
};

interface Vehicle {
  id: string;
  number_plate: string;
  make_model?: string;
  reg_date?: string;
  vehicles_owners_id?: string;
  fuel_type?: string;
  vehicle_status?: string;
}

const OrdersScreen: React.FC = () => {
  const params = new URLSearchParams(window.location.search);
  const vehicleId = params.get('vehicle_id');
  const location = useLocation();
  const userName = params.get('user_name') || '';
  const [orders, setOrders] = useState<any[]>([]);
  const [allOrders, setAllOrders] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [hasOrderCreated, setHasOrderCreated] = useState(false);
  const [odometerStart, setOdometerStart] = useState('');
  const [odometerPic, setOdometerPic] = useState<File | null>(null);
  const [odometerReading, setOdometerReading] = useState('');
  const [capturedImage, setCapturedImage] = useState<string | null>(null);
  const [odometerEnd, setOdometerEnd] = useState('');
  const [ordersPicked, setOrdersPicked] = useState('');
  const [ordersDelivered, setOrdersDelivered] = useState('');
  const [showPhotoSkipModal, setShowPhotoSkipModal] = useState(false);
  const [totalOrdersDelivered, setTotalOrdersDelivered] = useState('');
  const [handoverStatus, setHandoverStatus] = useState(false);
  const [openCameraDialog, setOpenCameraDialog] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(0);
  const [selectedVehicle, setSelectedVehicle] = useState<Vehicle | null>(null);
  const [isStartTrip, setIsStartTrip] = useState(false);
  const [actionType, setActionType] = useState('');

  const [vehicles, setVehicles] = useState([]);
  const [showTripForm, setShowTripForm] = useState(false);
  const [currentTrip, setCurrentTrip] = useState({
    id: null,
    odometer_start: '',
    orders_picked: '',
    errors: null,
    start_time: '',
    status: '',
    initiated_by:''
  });  
  const [tripId, setTripId] = useState<string | null>(null); 
  const [urlParams, setUrlParams] = useState({
    token: '',
    userId: '',
  });
  const [currentLocation, setCurrentLocation] = useState({
    latitude: null as number | null,
    longitude: null as number | null,
  });
  
  const [tripConfirmationModal, setTripConfirmationModal] = useState<{
    open: boolean;
    type: 'start' | 'end';
    companyName?: string;
    ofdCount?: string;
  }>({
    open: false,
    type: 'start'
  });

  const [activeTooltip, setActiveTooltip] = useState<string | null>(null);
  
  const navigate = useNavigate();
  const containerRef = useRef<HTMLDivElement>(null);


  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const userPhoneFromQuery = queryParams.get('user_phone');
    const userPhone = userPhoneFromQuery || localStorage.getItem("user_phone") || '';

    if (userPhone) {
      localStorage.setItem("user_phone", userPhone);
    }  
    setUrlParams({
      token: queryParams.get('token') || '',
      userId: queryParams.get('user_id') || '',
    });
        
    if (vehicleId) {
      fetchOrders(0, true);
    }
        refreshTripData();
    getOrdersDelivered((response: { message: { total_orders_delivered: React.SetStateAction<string>; }; })=>{
      setTotalOrdersDelivered(response.message.total_orders_delivered)
    },
    (error: { message: any; })=>{toast.error(error.message)})
  }, [vehicleId]);
 useEffect(() => {
  window.isReactAppReady = true;
  window.dispatchEvent(new CustomEvent('reactAppReady'));
  
  const handleLocationUpdate = (event) => {
    const locationData = event.detail;
     if (locationData && locationData.type === 'LOCATION_UPDATE' && locationData.data) {
      const { latitude, longitude } = locationData.data;
      
      setCurrentLocation({ latitude, longitude });
      
    } else {
      console.log("Invalid location data format:", locationData);
    }
  };

  
  window.addEventListener('locationUpdate', handleLocationUpdate);
  
  return () => {
    window.removeEventListener('locationUpdate', handleLocationUpdate);
  };
}, []);

  useEffect(()=>{
    getOrders(
      50,
      0,
      '',
      '',
      '',
      tripId,
      '',
      '',
      '',
      '',
      vehicleId,
      '',
      1,
      (response: { message: { total_count: number; }; }) => {
        if (response?.message?.total_count > 0) {
          setHandoverStatus(true);
        } else {
         setHandoverStatus(false);
        }
      },
     (error: string) => {
        toast.error("Error checking orders: " + error);
      }
    );
  },[tripId])

const refreshTripData = () => {
  getDashboard(
      (response: { status: number; message: { vehicles: any[] | ((prevState: never[]) => never[]); current_trip: any; }; }) => {  
      if (response.status === 200) {
        setVehicles(response.message.vehicles);       
        const primaryVehicle = response.message.vehicles.find((v: { vehicle_status: string; }) => v.vehicle_status === 'primary');
        const processedTrip = processCurrentTrip(response.message.current_trip, response.message.vehicles);
        setSelectedVehicle(primaryVehicle)
        setCurrentTrip(processedTrip);
        setTripId(processedTrip.id);
        if (processedTrip.start_time === null || processedTrip.errors === 'Trip not found') {
          setActionType('start');   
        } else {
          setActionType('end');
        }
      } else {
        toast.error(response.message);
      }                   
    },
    (errorMessage) => {
      toast.error(errorMessage.message.errors);
    }
  );
};

const refreshOrders = () => {
  fetchOrders(0, true);
};

  const handleHandoverClick = () => {
    editTrips(tripId,'',ordersDelivered,ordersPicked,odometerEnd,'handover',(response: { message: any; }) => {  toast.success(response.message);
 setOdometerReading('');
          setOrdersPicked('');
          setOrdersDelivered('');
          setShowTripForm(false);
          setOdometerStart('');
          setOdometerEnd('');
          setOdometerPic(null);
          refreshTripData();
          refreshOrders();
    },(error: { message: any; }) => {toast.error(error.message)
    })
  
  };
    useEffect(() => {
  
      if (odometerPic) {
    const hasStartTime = currentTrip && currentTrip.start_time;
    const hasEndTime = currentTrip && currentTrip.end_time;
    const isHandoverStatus = currentTrip.status === 'handover';
        if (hasStartTime && !hasEndTime && !isHandoverStatus && handoverStatus) {
      handleHandoverClick();
    } else {
      startEndTrip();
    }
      }
    }, [odometerPic]);
const proceedWithTripStart = () => {
  setShowTripForm(true);
  setTripConfirmationModal({ open: false, type: 'start' });
};
const checkOrdersStatus = () => {
    if (actionType === 'end') {
      getOrders(
        50,
        0,
        'OFD',
        '',
        '',
        tripId,
        '',
        '',
        '',
        '',
        vehicleId,
        '',
        1,
          (response: { message: { total_count: number; }; }) => {
          if (response?.message?.total_count > 0) {
            setTripConfirmationModal({
              open: true,
              type: 'end',
              ofdCount: response.message.total_count.toString()
            });
          } else {
            proceedWithTripStart();
          }
        },
        (error: string) => {
          toast.error("Error checking orders: " + error);
          proceedWithTripStart();
        }
      );
    } else {
      getOrders(
        50,
        0,
        'vehicle assigned',
        '',
        '',
        tripId,
        '',
        '',
        '',
        '',
        vehicleId,
        '',
        1,
        (response: { message: { total_count: number; }; }) => {
          if (response?.message?.total_count > 0) {
           proceedWithTripStart();
          } else {
           return;
          }
        },
        (error: string) => {
          toast.error("Error checking orders: " + error);
          proceedWithTripStart();
        }
      );
    }
  };
  
const handleTripButtonClick = async (skipConfirmation: boolean = false) => {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify({
      type: 'START_TRIP'
    }));
    
    const handleLocationResponse = (event: any) => {
      const locationData = event.detail || event;
      
      if (locationData.type === 'LOCATION_ERROR') {

        window.removeEventListener('locationUpdate', handleLocationResponse);
        return;
      }
      
      if (locationData.type === 'LOCATION_UPDATE' && locationData.data) {
        const { latitude, longitude } = locationData.data;
        setCurrentLocation({ latitude, longitude });
        
        if (!selectedVehicle) {
          toast.error("Vehicle is not mapped. Please Contact your Supervisor");
        } else {
          if (skipConfirmation) {
            proceedWithTripStart();
          } else {
            if (currentTrip.status === 'trip started' && handoverStatus) {
              getOrders(
                50, 0, 'delivered', '', '', tripId, '', '', '', '', vehicleId, '', 1,
                (response: { message: { total_count: number; }; }) => {
                  if (response?.message?.total_count > 0) {
                    setOrdersDelivered(response.message.total_count.toString());
                  } else {
                    setOrdersDelivered('0');
                  }
                },
                (error: string) => {
                  toast.error("Error fetching delivered orders: " + error);
                  setOrdersDelivered('');
                }
              );
            }
            checkOrdersStatus();
          }
        }
        
        window.removeEventListener('locationUpdate', handleLocationResponse);
      }
    };
    
    window.addEventListener('locationUpdate', handleLocationResponse);
    
    setTimeout(() => {
      window.removeEventListener('locationUpdate', handleLocationResponse);
    }, 10000);
    
  } else {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        setCurrentLocation({ latitude: latitude, longitude: longitude });
        
        if (!selectedVehicle) {
          toast.error("Vehicle is not mapped. Please Contact your Supervisor");
        } else {
          if (skipConfirmation) {
            proceedWithTripStart();
          } else {
            checkOrdersStatus();
          }
        }
      },
      (error) => {
        toast.error('Location access is required to start trip');
      }
    );
  }
};

  const cancelTripAction = () => {
    setShowTripForm(false);
    setOdometerReading('');
    setOrdersPicked('');
    setOrdersDelivered('');
  };

  const processCurrentTrip = (currentTripData: any, vehicleData: any) => {
    if (!currentTripData) return { errors: 'Trip not found' };
    const primaryVehicle = vehicleData.find((v: { vehicle_status: string; }) => v?.vehicle_status === 'primary');
    if (!primaryVehicle) return { errors: 'No primary vehicle found' };
    const vehicleTrip = currentTripData[primaryVehicle?.id];
    return vehicleTrip || { errors: 'Trip not found' };
  };
  const handleOdometerChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value === '' || /^[0-9]*$/.test(value)) {
      setOdometerReading(value);
    }
    if(actionType ===  'start'){
      setOdometerStart(value);
    } else {
      setOdometerEnd(value);
    }
  };

  const handleOrdersChange = (action: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value === '' || /^[0-9]*$/.test(value)) {    
      if (action === 'start') {
        setOrdersPicked(value);
      } else {
        setOrdersDelivered(value);
      }
    }
  };

 


  const fetchOrders = useCallback(async (pageNumber: number, isInitialLoad: boolean = false) => {
    if (isInitialLoad) setLoading(true);
    else setLoadingMore(true);

    const limit = 50;
    getOrders(
      limit,
      pageNumber,
      '',
      '',
      tripId,
      '',
      
      '',
      '',
      '',
      '',
      vehicleId,
      '',
      1,
      async (response: { message: { orders_list: never[]; }; }) => {
        const ordersList = response.message.orders_list || [];

        if (isInitialLoad) {
          setAllOrders(ordersList);
          setOrders(ordersList);
        } else {
          const updatedAllOrders = [...allOrders, ...ordersList];
          setAllOrders(updatedAllOrders);
          setOrders(updatedAllOrders);
        }

        if (ordersList.length < limit) setHasMore(false);
        else setHasMore(true);
       const hasCreatedOrder = ordersList.some((order: { status: string; }) =>
  ['vehicle assigned', 'ofd', 'attempted'].includes(order.status.toLowerCase())
);
        setHasOrderCreated(hasCreatedOrder);

        setLoading(false);
        setLoadingMore(false);
      },
      (error) => {
        toast.error(error);
        setLoading(false);
        setLoadingMore(false);
      }
    );
  }, [vehicleId, allOrders, tripId]);

  const handleScroll = useCallback(() => {
    if (!containerRef.current || loadingMore || !hasMore) return;

    const { scrollTop, scrollHeight, clientHeight } = containerRef.current;
    const scrollThreshold = 100;

    if (scrollHeight - scrollTop - clientHeight < scrollThreshold) {
      const nextPage = page + 1;
      setPage(nextPage);
      fetchOrders(nextPage);
    }
  }, [page, loadingMore, hasMore, fetchOrders]);

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      container.addEventListener('scroll', handleScroll);
      return () => container.removeEventListener('scroll', handleScroll);
    }
  }, [handleScroll]);

  useEffect(() => {
    if (allOrders.length === 0) return;

    if (actionType === 'start') {
      const filteredOrders = allOrders.filter(order =>
        ['vehicle assigned', 'ofd', 'attempted'].includes(order.status.toLowerCase())
      );
      setOrders(filteredOrders);
    } 
    else if (actionType === 'end' && tripId) {
      const sameTripOrders = allOrders.filter(order =>
        order.trip_id === tripId &&
        ['ofd', 'attempted','delivered', 'partially delivered'].includes(order.status.toLowerCase())
      );

      const vehicleAssignedOrders = allOrders.filter(order =>
        order.status.toLowerCase() === 'vehicle assigned'
      );

      setOrders([...sameTripOrders, ...vehicleAssignedOrders]);
    } 
    else {
      setOrders(allOrders);
    }
  }, [actionType, tripId, allOrders]);

  const handleBack = () => {
    navigate(`/wv/dashboard?user_name=${userName}&vehicle_id=${vehicleId}&user_id=${urlParams.userId}&token=${urlParams.token}`);
  };

const handleTripConfirmationModal = () => {
  if (tripConfirmationModal.type === 'start') {
    proceedWithTripStart();
  } else {
     proceedWithTripStart();
  }
  setTripConfirmationModal({ open: false, type: tripConfirmationModal.type });
};

  const handleTripCancel = () => {
    setTripConfirmationModal({ open: false, type: tripConfirmationModal.type });
    if (actionType === 'start') {
      setTripId(null);
      navigate(`/wv/dashboard?user_name=${userName}&user_id=${urlParams.userId}&token=${urlParams.token}&vehicle_id=${vehicleId}`, {
        state: { startTrip: true }
      });
    }
  };
  useEffect(() => {
    const is2WEV = selectedVehicle?.fuel_type === '2W-EV';
    if (tripId !== null) {
      if (is2WEV) {
      if (currentTrip?.orders_picked  && currentTrip?.initiated_by !== 'driver' && currentTrip.orders_picked.toString().trim() !== '') {
        setOrdersPicked(currentTrip.orders_picked.toString());
      } else {
          setOrdersPicked('');
        }
      } else {
        if (actionType === "start") {
          if (currentTrip?.orders_picked && currentTrip?.initiated_by !== 'driver') {
            setOrdersPicked(currentTrip.orders_picked.toString());
          } else {
            setOrdersPicked('');
          }
        } else {
          setOrdersPicked('');
        }
      }
    } else {
      setOrdersPicked('');
    }
  }, [tripId, actionType, currentTrip, selectedVehicle]);
const startEndTrip = () => {
    if (currentTrip.start_time === null || currentTrip.errors === 'Trip not found'){
      setIsStartTrip(true); 
      setTripId(currentTrip?.id)
    } else {
      setTripId(currentTrip.id);
      setIsStartTrip(false); 
    }
    
    if (parseInt(odometerEnd) < parseInt(currentTrip.odometer_start)) {
      toast.error("End Odometer Reading must be greater than Start Odometer Reading.");
      return;
    }
    
    if (parseInt(currentTrip?.orders_picked || ordersPicked) < parseInt(ordersDelivered)) {
      toast.error("Order Delivered should be less than order picked up");
      return;
    }
    
    const is2WEV = selectedVehicle?.fuel_type === '2W-EV';
    const ordersToSend = {
      start: is2WEV && actionType === 'start' ? '' : ordersPicked,
      end: ordersDelivered
    };
    startEndTripApi(currentLocation.latitude, currentLocation.longitude, tripId, vehicleId, actionType === 'end' ? 1 :0, (response: { data: { status: number; message: { errors: { latitude: any; longitude: any; }; trip_id: null; message: any; }; }; }) => {
      if(response.data.status === 400) {
        if(response.data.message.errors.latitude|| response.data.message.errors.longitude ){
          toast.error("Please enable your Location Services")
        } else {
          toast.error("Please contact your supervisor")
        }
      } else if (response.data.status === 200 || response.data.status === 201) {
        if(response.data.message.trip_id !== null) { 
          toast.success(response.data.message.message);
          setOdometerReading('');
          setOrdersPicked('');
          setOrdersDelivered('');
          setShowTripForm(false);
          setOdometerStart('');
          setOdometerEnd('');
          setOdometerPic(null);

        }
      } else if (response.data.status=== 400){
        toast.error(response?.data?.message?.errors?.latitude || response?.data?.message?.errors?.longitude || response?.data?.message || 'Please Try Again')
      }
      refreshTripData();
        
        refreshOrders();
    },
    (errorMessage: { message: any; }) => {
      toast.error(errorMessage.message);
    }, actionType, odometerPic, odometerStart, odometerEnd, ordersToSend.start,
    ordersToSend.end)
  };
  const handleTripClose = () => {
    setTripConfirmationModal({ open: false, type: tripConfirmationModal.type });
  };


  const formatSlotDateTime = (dateTimeString: string | null) => {
    if (!dateTimeString) return 'Not scheduled';
    const date = new Date(dateTimeString);
    return `${date.toLocaleDateString()} ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
  };

  const handleOrderClick = (order: any) => {
    const status = order.status.toLowerCase();
    
    if (status === 'vehicle assigned') {
      setActiveTooltip(order.id);
      setTimeout(() => setActiveTooltip(null), 3000); 
      return;
    }
    
    if (status === 'ofd' || status === 'attempted') {
      navigate(`/wv/route?vehicle_id=${vehicleId}&user_id=${urlParams.userId}&token=${urlParams.token}`, {
        state: {
          id: order.id,
          order_id: order.order_id,
          name: order.customer_name,
          address: order.customer_address,
          pincode: order.customer_pincode,
          order_type: order.type || 'Standard',
          payment_mode: order.cod ? 'COD' : 'Prepaid',
          amount: order.amount || 0,
          ...order
        },
      });
    } else {
      navigate(`/wv/order-summary?token=${urlParams.token}`, {
        state: {
          id: order.id,
          order_id: order.order_id,
          name: order.customer_name,
          address: order.customer_address,
          pincode: order.customer_pincode,
          order_type: order.type || 'Standard',
          payment_mode: order.cod ? 'COD' : 'Prepaid',
          amount: order.amount || 0,
          ...order
        },
      });
    }
  };

  const handleShowTooltip = (orderId: string, e: React.MouseEvent) => {
    e.stopPropagation();
    setActiveTooltip(orderId);
    setTimeout(() => setActiveTooltip(null), 3000);  
  };

  const handleCloseTooltip = () => {
    setActiveTooltip(null);
  };

  const getFilteredOrders = () => {
    return orders;
  };

  const filteredOrders = getFilteredOrders();
  
  const getTripButton = () => {
    const buttonState = getTripButtonState(currentTrip, handoverStatus);
    return (
      <Button
        variant="contained"
        fullWidth
        disabled={buttonState.disabled}
        sx={{
          backgroundColor: buttonState.backgroundColor,
          fontSize: '1.1rem',
          lineHeight: '1.2',
          '&:hover': {
            backgroundColor: buttonState.disabled ? buttonState.backgroundColor : 
              buttonState.type === 'start' ? '#1CA825' :
              buttonState.type === 'end' ? '#E63939' :
              buttonState.type === 'handover' ? '#C67A14' : buttonState.backgroundColor
          },
          '&.Mui-disabled': {
            backgroundColor: '#E0E0E0',
            color: '#9E9E9E'
          }
        }}
        onClick={buttonState.disabled ? undefined : () => handleTripButtonClick(false)}
      >
        {buttonState.label}
      </Button>
    );
  };
  return (
    <ClickAwayListener onClickAway={handleCloseTooltip}>
      <Container maxWidth="sm" sx={{ padding: 2 }}>
       <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 , marginTop:'20px'}}>
  <Heading title="Orders" onBackClick={handleBack} />
  {hasOrderCreated && (
    <Box sx={{ width: '40.3%' }}> 
      {getTripButton()}
    </Box>
  )}
</Stack>

        <Box
          ref={containerRef}
          sx={{
            marginTop: 3,
            overflowY: 'auto',
            maxHeight: '80vh',
            '&::-webkit-scrollbar': { width: '8px' },
            '&::-webkit-scrollbar-track': { background: '#f1f1f1' },
            '&::-webkit-scrollbar-thumb': { background: '#888', borderRadius: '4px' },
            '&::-webkit-scrollbar-thumb:hover': { background: '#555' },
          }}
        >
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
              <CircularProgressWithLabel label='Loading...' />
            </Box>
          ) : filteredOrders.length === 0 ? (
            <Typography sx={{ textAlign: 'center', p: 3 }}>
              {actionType === 'start'
                ? 'No orders found'
                : actionType === 'end'
                  ? `No orders found`
                  : 'No orders found'}
            </Typography>
          ) : (
            <>
              {filteredOrders.map((order) => {
                const statusKey = order.status.toLowerCase();
                const statusColors = statusColorMap[statusKey] || {
                  light: '#ffffff',
                  dark: '#000000',
                };

                const customer = {
                  name: order.customer_name || `Customer ${order.customers_id}`,
                  address: order.customer_address || 'Address not available',
                  pincode: order.customer_pincode || 'N/A'
                };

                const isVehicleAssigned = statusKey === 'vehicle assigned';

                return (
                  <Box key={`${order.id}-${order.order_id}`} sx={{ position: 'relative', mb: 2 }}>
                    {activeTooltip === order.id && isVehicleAssigned && (
                      <Paper
                        sx={{
                          position: 'absolute',
                          top: -10,
                          left: '50%',
                          transform: 'translateX(-50%)',
                          zIndex: 10,
                          padding: '8px 12px',
                          backgroundColor: 'rgba(0, 0, 0, 0.8)',
                          color: 'white',
                          borderRadius: 2,
                          fontSize: '0.875rem',
                          maxWidth: '200px',
                          textAlign: 'center',
                          '&::after': {
                            content: '""',
                            position: 'absolute',
                            bottom: -8,
                            left: '50%',
                            transform: 'translateX(-50%)',
                            width: 0,
                            height: 0,
                            borderLeft: '8px solid transparent',
                            borderRight: '8px solid transparent',
                            borderTop: '8px solid rgba(0, 0, 0, 0.8)',
                          }
                        }}
                      >
                        Trip should be started to deliver this order
                      </Paper>
                    )}

                    <Card
                      variant="outlined"
                      onClick={() => handleOrderClick(order)}
                      sx={{
                        backgroundColor: statusColors.light,
                        borderRadius: 2,
                        padding: 1,
                        cursor: isVehicleAssigned ? 'default' : 'pointer',
                        '&:hover': {
                          boxShadow: isVehicleAssigned ? 0 : 3
                        },
                        position: 'relative',
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          marginBottom: 1,
                        }}
                      >
                        <Box sx={{ display: 'flex', gap: 1 }}>
                          <Chip
                            label={order.type || 'Standard'}
                            size="small"
                            sx={{
                              backgroundColor: '#ffffff',
                              color: '#000',
                              border: '1px solid #ccc',
                            }} />
                          <Chip
                            label={order.cod ? 'COD' : 'Prepaid'}
                            size="small"
                            sx={{
                              backgroundColor: '#ffffff',
                              color: '#000',
                              border: '1px solid #ccc',
                            }} />
                        </Box>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <Chip
                            label={order.status.toLowerCase() === 'ofd' ? 'Out For Delivery' : order.status}
                            size="small"
                            sx={{
                              backgroundColor: statusColors.dark,
                              color: '#fff',
                              textTransform: 'capitalize',
                            }} />
                          {isVehicleAssigned && (
                            <IconButton
                              size="small"
                              onClick={(e) => handleShowTooltip(order.id, e)}
                              sx={{
                                color: statusColors.dark,
                                padding: '4px',
                                '&:hover': {
                                  backgroundColor: 'rgba(0, 0, 0, 0.04)'
                                }
                              }}
                            >
                              <InfoOutlined fontSize="small" />
                            </IconButton>
                          )}
                        </Box>
                      </Box>

                      <CardContent sx={{ paddingTop: 0 }}>
                        <Typography variant="subtitle2" sx={{ textDecoration: 'underline' }}>
                          Order ID: {order.order_id}
                        </Typography>
                        <Typography fontWeight="bold">{customer.name}</Typography>
                        <Typography>{customer.address}</Typography>
                        <Typography>Pincode: {customer.pincode}</Typography>
                        {actionType === 'end' && (
                          <Typography variant="body2" color="text.secondary">
                            Trip ID: {order.trip_id}
                          </Typography>
                        )}

                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 1 }}>
                          <Typography variant="body2">Slot: {formatSlotDateTime(order.slot_date_time)}</Typography>
                          <IconButton color="primary" aria-label="call">
                            <PhoneIcon />
                          </IconButton>
                        </Box>
                      </CardContent>
                    </Card>
                  </Box>
                );
              })}

              {loadingMore && (
                <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
                  <CircularProgressWithLabel size={24} />
                </Box>
              )}
              {!hasMore && filteredOrders.length > 0 && (
                <Typography sx={{ textAlign: 'center', p: 2, color: 'text.secondary' }}>
                  No more orders to load
                </Typography>
              )}
            </>
          )}
        </Box>
        
        <TripConfirmationModal
          open={tripConfirmationModal.open}
          onCancel={handleTripCancel}
          onClose={handleTripClose}
          onConfirm={handleTripConfirmationModal}
          type={tripConfirmationModal.type}
          companyName={tripConfirmationModal.companyName}
          ofdCount={tripConfirmationModal.ofdCount} 
        />
        <PhotoConfirmationModal
          open={showPhotoSkipModal}
          onClose={() => setShowPhotoSkipModal(false)}
          onSkip={() => {
            const hasStartTime = currentTrip && currentTrip.start_time;
            const hasEndTime = currentTrip && currentTrip.end_time;
            const isHandoverStatus = currentTrip.status === 'handover';
          
            if (hasStartTime && !hasEndTime && !isHandoverStatus && handoverStatus) {
              handleHandoverClick();
            } else {
              startEndTrip();
            }
          }}
          onTakePhoto={() => {
            setOpenCameraDialog(true);
          }}
        />
        <CameraDialog
          open={openCameraDialog}
          onClose={() => {
            setOpenCameraDialog(false);
            setCapturedImage(null);
          }}
          onCapture={(imageData) => {
            setOdometerPic(imageData.file);
          }}
          capturedImage={capturedImage}
          setCapturedImage={setCapturedImage}
        />
        {showTripForm && (
          <TripForm
            open={showTripForm}
            onClose={cancelTripAction}
            onNext={() => setShowPhotoSkipModal(true)}
            onCancel={cancelTripAction}
            actionType={actionType}
            selectedVehicle={selectedVehicle}
            odometerReading={odometerReading}
            onOdometerChange={handleOdometerChange}
            ordersPicked={ordersPicked}
            onOrdersPickedChange={handleOrdersChange('start')}
            ordersDelivered={ordersDelivered}
            onOrdersDeliveredChange={handleOrdersChange('end')}
            currentTrip={currentTrip}
            handoverStatus={handoverStatus}
          />
        )}
      </Container>
    </ClickAwayListener>
  );
};

export default OrdersScreen;